import { SelectOption } from '@Components/Selectors/Select'
import { UserGroup } from '@Entities/user/user'

export const transformUserGroupsToSelectOptions = (userGroups: UserGroup[]): SelectOption[] =>
    userGroups.map((item: UserGroup) => {
        const { name } = item

        return {
            label: name,
            value: name,
            id: name,
        }
    })
